// @flow
import React, { Fragment } from 'react';

import moment from 'moment';

import { roundOff } from '../../../../lib/utils';
import type { Flight } from '../../../../components/Flights/flowTypes';

type Props = {
  flight: Flight,
  title: string,
  pax: number,
};

const FlightCard = (props: Props) => {
  const {
    departure,
    arrival,
    arrival_time,
    departure_time,
    refundable,
    free_baggage,
    airline_code,
    flight_no,
    currency,
    flight_date,
    total_amount,
  } = props.flight;

  const perPersonFlightPrice = roundOff(total_amount / props.pax, 2);

  return (
    <Fragment>
      <h3 style={{ fontSize: '14px', marginBottom: '8px' }}>
        {props.title} {moment(flight_date).format('DD MMMM YYYY')}
      </h3>
      <div className="flight-info-card">
        <div className="d-flex justify-content-center">
          <span>{moment(flight_date).format('DD MMMM YYYY')}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="flight-logo-wrap">
            <div className="flight-logo">
              <img
                src="https://s3.amazonaws.com/honeyguide/assets/aillines.png"
                alt={airline_code}
              />
            </div>
            <p>{flight_no}</p>
            <p>Summit Airlines</p>
          </div>
          <div className="flight-detail">
            <div className="d-flex justify-content-between">
              <h5>{departure_time}</h5>
              <h5>{arrival_time}</h5>
            </div>
            <p className="vertical-line">&nbsp;</p>
            <div className="d-flex justify-content-between">
              <p>{departure}</p>
              <p>{arrival}</p>
            </div>
          </div>
          <div className="flight-price">
            <h5>
              {currency} {perPersonFlightPrice}
            </h5>
            <p>per person</p>
            <p>
              {refundable === 'T'
                ? 'Refundable'
                : refundable === 'F'
                ? 'Non-Refundable'
                : ''}
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <span>{free_baggage && `${free_baggage} KG max baggage`}</span>
        </div>
      </div>
    </Fragment>
  );
};

export default FlightCard;



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/PreSelectedFlightCards.js